import HBModal from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import { getAdaptiveImg } from "@/utils/imageUrl";
import { Button } from "antd";
import styles from "./index.module.less";

function RawCancelConfirmModal({ onCancel, onOk, ...props }) {
  const back = getAdaptiveImg(
    "https://st0.dancf.com/static/02/202209130355-16d9.png",
    {
      width: 480,
    }
  );

  return (
    <HBModal
      className={styles.confirm}
      footer={null}
      width={480}
      maskClosable={false}
      closable={false}
      {...props}
    >
      <div className={styles.body} style={{ backgroundImage: `url(${back})` }}>
        <div className={styles.content}>
          <div className={styles.title}>您目前拥有优惠购买特权</div>
          <div>退出后将无法享用</div>
        </div>
        <div className={styles.footer}>
          <Button onClick={onCancel}>确定放弃</Button>
          <Button type="primary" onClick={onOk}>
            继续支付
          </Button>
        </div>
      </div>
    </HBModal>
  );
}

const CancelConfirmModal = ModalWrap(RawCancelConfirmModal);

export default CancelConfirmModal;
